import { useEffect, useState } from 'react';
import { getReauthReason, onReauthChange } from '../utils/helpers/sessionManager';

const useReauthReason = () => {
  const [reason, setReason] = useState(getReauthReason);

  useEffect(() => {
    setReason(getReauthReason());
    return onReauthChange(setReason);
  }, []);

  return reason;
};

export default useReauthReason;
